<template>
  <div class="com-page">
    <div class="content-nav">
      <div class="content-nav-left">
        <div class="nav-icon" @click="returnHome">
          <i class="iconfont iconzu41 cursor" title="首页" />
        </div>
        <div class="nav-menu">
          <el-menu router :default-active="$route.path" mode="horizontal" background-color="#C8102D" text-color="#fff">
            <el-menu-item :index="canTrade?'/trade/index':''" :disabled="!canTrade" v-if="employeeLevel !==85">渠道项目</el-menu-item>
            <el-menu-item index="" disabled v-if="employeeLevel !==85">资产管理</el-menu-item>
            <el-menu-item index="/bcc/approveOrder"  v-if="isBccProduct">订单管理</el-menu-item>
            <el-menu-item index="/bcc/material/list"  v-if="isBccProduct">物料管理</el-menu-item>
            <el-menu-item index="/bcc/user/list"  v-if="isBccProduct">人员账号管理</el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="content-nav-right nav-menu" v-if="employeeLevel !==85">
        <el-menu router :default-active="$route.path" mode="horizontal" background-color="#C8102D" text-color="#fff">
          <!-- <el-menu-item :index="canBudget?'/budget/index':''" :disabled="!canBudget">预算管理</el-menu-item> -->
          <el-menu-item :index="reportShow?'/report/index':''" :disabled="!reportShow">报表中心</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'headerNav',
  data () {
    return {
      path: '',
      employeeLevel: '',
      defaultBuType: '',
      canBudget: false,
      reportShow: false,
      canTrade: false,
      approveOrder: false
    }
  },

  computed: {
    ...mapGetters([
      'userInfo'
    ]),

    isBccProduct () {
      const { clientAuthorizationCodeList } = this.userInfo
      return clientAuthorizationCodeList && clientAuthorizationCodeList.includes('bcc:product-vendor:maint')
    },
  },
  created () {
    this.defaultBuType = this.userInfo.defaultBuType
    this.employeeLevel = this.userInfo.employeeLevel
    this.init()
  },
  methods: {
    init () {
      // 预算管理
      if (this.employeeLevel === 45 || this.employeeLevel === 50) {
        this.canBudget = true
      }
      // 渠道项目
      if (!(!this.employeeLevel || this.employeeLevel < 40)) {
        this.canTrade = true
      }
      // 报表中心
      // 拥有等级 && 等级大于等于40 && 默认是百威01
      if (this.employeeLevel && this.employeeLevel >= 40 && this.defaultBuType === '01') {
        this.reportShow = true
      }
    },
    returnHome () {
      this.$router.push({ path: '/' })
    },
  }
}
</script>

<style lang="scss" scoped>
.com-page {
  height: 40px;
  background-color: $base-red;
  .content-nav {
    width: 1200px;
    height: 100%;
    margin: auto;
    overflow-y: hidden;
    color: $base-white;
    box-sizing: border-box;
    padding: 0 $content-large;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .content-nav-left {
      display: flex;
      align-items: center;
      .iconzu41 {
        font-size: 24px;
      }
      .nav-menu {
        margin-left: $page-middle;
      }
    }
  }
}
</style>
